<script setup>
  const props = defineProps({
    disabled: {
      default: false,
      type: Boolean
    },
    type: {
      default: 'submit',
      type: String
    }
  })
</script>

<template>
  <button
    :type="props.type"
    :disabled="props.disabled"
    class="px-3
            py-2
            rounded-md
            shadow
            disabled:text-gray-200
            disabled:bg-gray-200
            disabled:shadow-none"
  >
    <slot />
  </button>
</template>

<style scoped>

</style>
